import React, { useEffect, useState } from "react";
import { MarqueeSelection } from "@fluentui/react/lib/MarqueeSelection";
import { DetailsList, DetailsListLayoutMode, IColumn, Selection, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { ProviderConsumer as FluentUIThemeConsumer } from '@fluentui/react-northstar';
import { ThemeColorScheme } from "../shared/common/TeamsTheme";
import { EnumSortOrderType } from "../tikit/toolbar/CustomViewContextProvider";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SETTINGS_PAGES } from "../shared/utils/constants";
import { NameUserAvatar } from "./NameUserAvatar";


const _onColumnClick = (onColumnClickCallback: (column: IColumn) => void) => (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
  onColumnClickCallback(column);
};

const UserDetailList = (props) => {
  const [selection, setSelection] = useState<Selection | undefined>();
  const [columns, setColumns] = useState([] as IColumn[]);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const _selection: Selection = new Selection({ onSelectionChanged: () => { } });
    setSelection(_selection);

    setColumns(userColumns());
  }, [props.rows])

  const renderRecord = (key: string) => (item) => {
    if (key == 'FullName')
      return <div onClick={() => history.push((location.pathname.indexOf('/settings/') != -1) ? `/settings/${SETTINGS_PAGES.USERS}/${item.Id}` : `/${SETTINGS_PAGES.USERS}/${item.Id}`)} className="cursor-pointer" style={{ color: "var(--mgt-theme-brand-foreground)" }}><NameUserAvatar user={item} /></div>

    return <span>{item[key]}</span>;
  };
  const userColumns = (): IColumn[] => {
    return [
      {
        key: 'FullName', name: t('users.user-form.name'), minWidth: 250, maxWidth: 350, isMultiline: false, onRender: renderRecord('FullName'),
        isSorted: props.sortOrder.orderBy === 'FullName' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'FullName' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: false
      },
      {
        key: 'Email', name: t('users.user-form.email-address'), minWidth: 350, isMultiline: false, onRender: renderRecord('Email'),
        isSorted: props.sortOrder.orderBy === 'Email' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'Email' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: false
      },
      {
        key: 'Department', name: t('users.user-form.department'), minWidth: 150, maxWidth: 150, isMultiline: false, onRender: renderRecord('Department'),
        isSorted: props.sortOrder.orderBy === 'Department' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'Department' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: true
      },
      {
        key: 'JobTitle', name: t('users.user-form.job-title'), minWidth: 150, maxWidth: 150, isMultiline: false, onRender: renderRecord('JobTitle'),
        isSorted: props.sortOrder.orderBy === 'JobTitle' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'JobTitle' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: false
      },
      {
        key: 'OfficePhone', name: t('users.user-form.office-phone'), minWidth: 125, maxWidth: 125, isMultiline: false, onRender: renderRecord('OfficePhone'),
        isSorted: props.sortOrder.orderBy === 'OfficePhone' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'OfficePhone' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: true
      },
      {
        key: 'MobilePhone', name: t('users.user-form.mobile-phone'), minWidth: 125, maxWidth: 125, isMultiline: false, onRender: renderRecord('MobilePhone'),
        isSorted: props.sortOrder.orderBy === 'MobilePhone' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'MobilePhone' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: true
      },
      {
        key: 'productNames', name: t('users.tabs.licenses'), minWidth: 150, maxWidth: 150, isMultiline: true, onRender: renderRecord('productNames'),
        isSorted: props.sortOrder.orderBy === 'productNames' ? true : null, isSortedDescending: props.sortOrder.orderBy === 'productNames' && props.sortOrder.orderType === EnumSortOrderType.desc,
        onColumnClick: _onColumnClick(props.onColumnClick), isResizable: true, isCollapsible: false
      }
    ]
  }

  return selection ? (<FluentUIThemeConsumer render={(globalTheme) => (
    <div className={`py-3.5 pl-2.5 min-h-32`} style={{ backgroundColor: 'var(--mgt-theme-background2)', ...ThemeColorScheme(globalTheme.siteVariables) }}>
      <MarqueeSelection selection={selection}>
        <DetailsList items={props.rows} compact={false} columns={columns} selectionMode={SelectionMode.none} setKey='multiple' layoutMode={DetailsListLayoutMode.justified} isHeaderVisible={true} selection={selection}
          selectionPreservedOnEmptyClick={true} enterModalSelectionOnTouch={true} ariaLabelForSelectionColumn='Toggle selection' ariaLabelForSelectAllCheckbox='Toggle selection for all items' checkButtonAriaLabel='select row' />
      </MarqueeSelection>
    </div>
  )} />) : (<></>);
}

export default UserDetailList;